var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"footer"},[_c('div',{staticClass:"left"},[_c('span',[_vm._v("© 2015-2020 "),_c('span',{staticClass:"b-logo tx-bold"},[_vm._v(" OurMall")])])]),_c('div')])
}]

export { render, staticRenderFns }